import * as React from "react";

import { cn } from "~/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    const innerRef = React.useRef<HTMLTextAreaElement>(null);

    // Combine the forwarded ref and the local ref

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    React.useImperativeHandle(ref, () => innerRef.current!);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (props.onChange) {
        props.onChange(event); // Call the provided onChange handler
      }
      adjustHeight();
    };

    const adjustHeight = () => {
      const textarea = innerRef.current;
      if (textarea) {
        textarea.style.height = "auto"; // Reset height to auto to recalculate
        textarea.style.height = `${textarea.scrollHeight}px`; // Set height based on scrollHeight
      }
    };

    React.useEffect(() => {
      adjustHeight();
    }, []);

    return (
      <textarea
        ref={innerRef}
        rows={1}
        className={cn(
          "flex min-h-[80px] w-full resize-none overflow-hidden rounded-md border border-border bg-input px-3 py-2 text-[16px] ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
        onChange={handleChange}
      />
    );
  },
);

Textarea.displayName = "Textarea";

export { Textarea };
